import { render, staticRenderFns } from "./ListApprove.vue?vue&type=template&id=ba2eb91c"
import script from "./ListApprove.vue?vue&type=script&lang=js"
export * from "./ListApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports